var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "artist"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Artist',
        params: {
          q: _vm.artist
        }
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.artist) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "find via"
    }
  }, [_c('a', {
    staticClass: "btn btn-google",
    attrs: {
      "href": _vm.googleUrl,
      "target": "_blank",
      "title": "Google Search"
    }
  }, [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#google"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-soundcloud",
    attrs: {
      "href": _vm.soundcloudUrl,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#soundcloud"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("\n          SoundCloud\n          "), (this.sources.soundcloud) ? _c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#verified"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-youtube",
    attrs: {
      "href": _vm.youtubeUrl,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#youtube"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("\n          YouTube\n          "), (this.sources.youtube) ? _c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#verified"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-lastfm",
    attrs: {
      "href": _vm.lastfmUrl,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#lastfm"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("\n          Last.fm\n          "), (this.sources.lastfm) ? _c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#verified"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-bandcamp",
    attrs: {
      "href": _vm.bandcampUrl,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#bandcamp"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("\n          Bandcamp\n          "), (this.sources.bandcamp) ? _c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#verified"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Extra options"
    }
  }, [_c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": _vm.alterationUrl,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#edit"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("\n          Suggest Edit\n        ")])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c3cec64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrackRow.vue
// module id = 2O+2
// module chunks = 1